export default {
  star: '收藏',
  playAgain: {
    name: '重玩机制',
    radioTitle: '可否重玩',
    inputTitle: '重玩次数',
    options: ['不可重玩', '可重玩'],
    unit: '次',
    unlimited: '无限次',
  },
  autoEndTime: {
    name: '操作时限',
    radioTitle: '操作时限限制',
    inputTitle: '操作时限',
    options: ['不限制', '限制'],
  },
  global_click: {
    name: '全局跳转',
    desc: '玩家在全屏范围内，点击任意地方即跳转商店下载页',
  },
  auto_click: {
    name: '自动跳转',
    desc: '任何无操作的自动跳转商店下载页',
  },
  yd_click: {
    name: '诱导点击',
    desc: '用户进行特殊操作后即跳转商店下载页',
  },
  colorConfig: {
    name: '颜色配置',
  },
  difficulty: {
    configured: '已配置',
    configure: '去配置',
    easy: {
      name: '简单难度',
    },
    medium: {
      name: '中等难度',
    },
    hard: {
      name: '困难难度',
    },
  },
  stars: {
    name: '收藏',
  },
  level: {
    name: '关卡机制',
  },
  score: {
    name: '分数机制',
  },
  jump: {
    name: '跳转机制',
  },
  time: {
    name: '时间机制',
  },
  rate: {
    name: '频率设定',
  },
  range: {
    name: '判定范围设定',
  },
  prob: {
    name: '概率设定',
  },
}
